import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { TableHeader } from "../commons";
import { TableHeadersType } from "../../constant/tableHeadersConstants/tableHeadersType";
import PeopleOnLeaveTableData from "./PeopleOnLeaveTable/PeopleOnLeaveTableData";
import { PeopleOnLeaveListType } from "../../redux/mySpace/mySpaceTypes";
type AppProps = {
  toggle: () => void;
  data: PeopleOnLeaveListType[] | [];
  isOpen: boolean;
};

export const PEOPLE_ON_LEAVE_TABLE_HEADERS: TableHeadersType[] = [
  {
    label: "NAME",
    value: "name",
  },
  {
    label: "ON LEAVE",
    value: "on_leave",
  },
];
const PeopleOnLeaveModal = ({ toggle, data, isOpen }: AppProps) => {
  return (
    <Modal
      centered
      isOpen={isOpen}
      toggle={toggle}
      size="lg"
      style={{
        maxWidth: "650px",
        width: "100%",
      }}
      backdrop="static"
    >
      <ModalHeader
        className="pt-3 pl-4 pb-3"
        id="cross-cut"
        toggle={toggle}
        style={{
          maxWidth: "650px",
          width: "100%",
        }}
      >
        People on leave
      </ModalHeader>
      <ModalBody
        style={{ height: "400px", padding: "1rem 0 1rem 0", overflowY: "auto" }}
      >
        <div className="mb-3 pl-4" style={{ color: "#6e7491" }}>
        Find the list of people who are on leave today and upcoming days.
        </div>
        <div className="disbursment table-responsive" style={{ width: "100%" }}>
          <table className="table">
            <thead className="sticky-table-header">
              <TableHeader tableHeader={PEOPLE_ON_LEAVE_TABLE_HEADERS} />
            </thead>
            <tbody>
              <PeopleOnLeaveTableData
                data={data}
                tableHeader={PEOPLE_ON_LEAVE_TABLE_HEADERS}
              />
            </tbody>
          </table>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default PeopleOnLeaveModal;
